import { CircularProgress, Grid, Typography } from '@mui/material';
import HighchartsReact from 'highcharts-react-official';
import highchartsMap from 'highcharts/modules/map';
import Highcharts from 'highcharts';
import React, { useEffect } from 'react';

interface ChartProps {
    map: boolean;
    options: any;
    loading: boolean;
    hasData: boolean;
    height: number;
    splitReportElement?: React.ReactNode;
}

Highcharts.setOptions({
    lang: {
        thousandsSep: ',',
    },
});

export const Chart = ({
    map,
    options,
    loading,
    hasData,
    height,
    splitReportElement,
}: ChartProps) => {
    useEffect(() => {
        if (map) {
            highchartsMap(Highcharts);
        }
    }, []);

    return (
        <React.Fragment>
            {loading ? (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height,
                    }}
                >
                    <CircularProgress />
                </div>
            ) : hasData ? (
                <Grid container flexDirection={'row'} display={'flex'}>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={splitReportElement ? 6 : 12}
                        lg={splitReportElement ? 6 : 12}
                        minHeight={height}
                    >
                        <HighchartsReact
                            constructorType={map ? 'mapChart' : ''}
                            highcharts={Highcharts}
                            options={options}
                        />
                    </Grid>

                    {Boolean(splitReportElement) && (
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={splitReportElement ? 6 : 12}
                            lg={splitReportElement ? 6 : 12}
                            justifyContent={'center'}
                        >
                            {splitReportElement}
                        </Grid>
                    )}
                </Grid>
            ) : (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height,
                    }}
                >
                    <Typography style={{ fontStyle: 'italic', fontSize: 18 }}>
                        No results found
                    </Typography>
                </div>
            )}
        </React.Fragment>
    );
};
